import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['phone'];

  connect() {
    this.phoneTargets.forEach((target) => {
      this.formatPhoneNumberInput(target);
      target.addEventListener('input', () => this.formatPhoneNumberInput(target));
    });
  }

  formatPhoneNumberInput(inputElement) {
    let input = inputElement.value;

    // If it starts with +, treat as international - no formatting
    if (input.startsWith('+')) {
      return;
    }

    // Strip non-digits for US number formatting
    let digitsOnly = input.replace(/\D/g, '');

    // Limit to 10 digits for US numbers
    if (digitsOnly.length > 10) {
      digitsOnly = digitsOnly.substring(0, 10);
    }

    let formattedInput = '';

    if (digitsOnly.length > 0) {
      formattedInput += '(' + digitsOnly.substring(0, 3);
    }
    if (digitsOnly.length >= 4) {
      formattedInput += ') ' + digitsOnly.substring(3, 6);
    }
    if (digitsOnly.length >= 7) {
      formattedInput += '-' + digitsOnly.substring(6, 10);
    }

    inputElement.value = formattedInput;
  }
}


